"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCarUsageSubform1PctMethodResults = void 0;
const utils_1 = require("../utils");
const utils_2 = require("./utils");
const FIXED_FLAT_RATE_DEDUCTION = 0.8;
const TRIPS_FIXED_RATE = 0.0003;
const FIXED_PRIVATE_USAGE_RATE = 0.01;
const validate1PctAmounts = (inputs) => {
    // Ignoring the following rule as we are destructing the object to omit the unused values.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { purchaseDate, carType } = inputs, numberValues = __rest(inputs, ["purchaseDate", "carType"]);
    const amounts = Object.values(numberValues);
    (0, utils_1.validateAmounts)(amounts);
};
/**
 * Updates `privateCarUsage` & `homeCompanyTrip` values based on `costCap`.
 * When costCap is negative we need to subtract it from `homeCompanyTrips`
 * and the remaining from `privateCarUsage`.
 */
const adjustPrivateCarUsageAndHomeCompanyTrips = ({ privateCarUsage, homeCompanyTrips, costCap, }) => {
    if (costCap < 0) {
        const activeCostCap = Math.abs(costCap);
        // If `activeCostCap` doesn't exceed `homeCompanyTrips`, subtract everything from it.
        // Else make `homeCompanyTrips` 0 (it shouldn't become negative) and subtract the remnant from `privateCarUsage`.
        if (activeCostCap <= homeCompanyTrips) {
            homeCompanyTrips -= activeCostCap;
        }
        else {
            const subtractionRemnant = activeCostCap - homeCompanyTrips;
            homeCompanyTrips = 0;
            privateCarUsage -= subtractionRemnant;
        }
    }
    return { privateCarUsage, homeCompanyTrips };
};
const calculateCarUsageSubform1PctMethodResults = (inputs, declarationYear) => {
    if (declarationYear <= 0) {
        throw new Error("Invalid declaration year");
    }
    validate1PctAmounts(inputs);
    const { actualCosts, catalogPrice, carType, collectedVat: collectedVatInput, commuteDistance, commuteDays, depreciationCosts, interestCosts, usageMonths, } = inputs;
    const reducedGrossPrice = (0, utils_2.getReducedGrossPrice)({
        grossPriceInCents: catalogPrice,
        carType,
    });
    const roundedGrossPrice = (0, utils_2.roundDownCentsToFullHundreds)(catalogPrice);
    // [106] Private Kfz-Nutzung
    let privateCarUsage = Math.round(reducedGrossPrice * FIXED_PRIVATE_USAGE_RATE * usageMonths);
    // [140] Vereinnahmte USt 19 % (Calculation is similar to [106] but we used only rounded price, not reduced).
    const collectedVatCalculation = Math.round(roundedGrossPrice * FIXED_PRIVATE_USAGE_RATE * usageMonths *
        FIXED_FLAT_RATE_DEDUCTION * utils_2.VAT_RATE);
    // [142] Fahrten zwischen Wohnung/Betrieb
    let homeCompanyTrips = Math.round(reducedGrossPrice * TRIPS_FIXED_RATE * usageMonths * commuteDistance);
    // [176] Min. abziehbare Fahrtkosten
    const minDeductibleTravelExpenses = (0, utils_2.getMinDeductibleTravelExpenses)({
        commuteDays,
        commuteDistance,
        declarationYear,
    });
    const costCap = actualCosts +
        interestCosts +
        depreciationCosts -
        (privateCarUsage + homeCompanyTrips);
    ({ privateCarUsage, homeCompanyTrips } =
        adjustPrivateCarUsageAndHomeCompanyTrips({
            privateCarUsage,
            homeCompanyTrips,
            costCap,
        }));
    // When user provides a manual `collectedVat` we use it instead of the calculated value, but we still
    // return both as part of the result for informational purposes.
    const collectedVat = collectedVatInput !== null && collectedVatInput !== void 0 ? collectedVatInput : collectedVatCalculation;
    // Gewinnerhöhung = [106] + [140] + [142] - [176]
    const profitIncrease = privateCarUsage +
        collectedVat +
        homeCompanyTrips -
        minDeductibleTravelExpenses;
    return {
        privateCarUsage,
        collectedVat,
        autoCalculatedCollectedVat: collectedVatCalculation,
        homeCompanyTrips,
        minDeductibleTravelExpenses,
        costCap,
        profitIncrease,
    };
};
exports.calculateCarUsageSubform1PctMethodResults = calculateCarUsageSubform1PctMethodResults;
//# sourceMappingURL=1PctMethod.js.map